import { useTheme } from '@emotion/react';
import { AutorenewOutlined } from '@mui/icons-material';
import AryLoadingButton from 'framework/base/components/AryLoadingButton';
import React from 'react';

export default function CommissionComponentChip({
  value,
  handleClick,
  trueValueLabel,
  falseValueLabel,
  disabled,
  isPersonRegistration,
  others
}) {
  const theme = useTheme();

  return (
    <AryLoadingButton
      checked={value}
      onClick={handleClick}
      endIcon={<AutorenewOutlined />}
      disabled={disabled}
      sx={{
        minWidth: '4rem',
        height: '1.6rem',
        padding: '0.125rem 0.25rem !important',
        marginRight: '0.25rem',
        fontSize: '0.75rem',
        fontWeight: '700',
        color: !isPersonRegistration
          ? value
            ? theme.text.green.color
            : theme.text.red.color
          : value
          ? theme.text.red.color
          : theme.text.green.color,
        background: theme.wrapper.grey25.backgroundColor,
        '&:hover': {
          backgroundColor: !isPersonRegistration
            ? value
              ? theme.chip.green.background
              : '#FDEEEE'
            : value
            ? '#FDEEEE'
            : theme.chip.green.background,
          boxShadow: !isPersonRegistration
            ? value
              ? '0px 2px 2px 0px #051C310A, 0px 2px 3px 0px #051C3114'
              : '0px 2px 2px 0px #051C310A,  0px 2px 3px 0px #051C3114'
            : value
            ? '0px 2px 2px 0px #051C310A,  0px 2px 3px 0px #051C3114'
            : '0px 2px 2px 0px #051C310A, 0px 2px 3px 0px #051C3114'
        },
        '&:focus': {
          backgroundColor: !isPersonRegistration
            ? value
              ? '#CCF4E8'
              : '#FBDCDC'
            : value
            ? '#FBDCDC'
            : '#CCF4E8',
          boxShadow: !isPersonRegistration
            ? value
              ? '0px 2px 3px 1px #051C3114, 0px 2px 4px 0px #051C3126'
              : '0px 2px 3px 1px #051C3114, 0px 2px 4px 0px #051C3126;'
            : value
            ? '0px 2px 3px 1px #051C3114, 0px 2px 4px 0px #051C3126;'
            : '0px 2px 3px 1px #051C3114, 0px 2px 4px 0px #051C3126;'
        }
      }}
      {...others}
    >
      {value ? trueValueLabel : falseValueLabel}
    </AryLoadingButton>
  );
}
